export const WhatsappToUserConstants = {
  FETCH_WHATSAPPTOUSER_REQUEST: "FETCH_WHATSAPPTOUSER_REQUEST",
  FETCH_WHATSAPPTOUSER_SUCCESS: "FETCH_WHATSAPPTOUSER_SUCCESS",
  FETCH_WHATSAPPTOUSER_FAILURE: "FETCH_WHATSAPPTOUSER_FAILURE",
  ADD_WHATSAPPTOUSER_REQUEST: "ADD_WHATSAPPTOUSER_REQUEST",
  ADD_WHATSAPPTOUSER_SUCCESS: "ADD_WHATSAPPTOUSER_SUCCESS",
  ADD_WHATSAPPTOUSER_FAILURE: "ADD_WHATSAPPTOUSER_FAILURE",
  WHATSAPPTOUSER_SEARCH_REQUEST: "WHATSAPPTOUSER_SEARCH_REQUEST",
  WHATSAPPTOUSER_SEARCH_SUCCESS: "WHATSAPPTOUSER_SEARCH_SUCCESS",
  WHATSAPPTOUSER_SEARCH_FAILURE: "WHATSAPPTOUSER_SEARCH_FAILURE",
  DOWNLOAD_WHATSAPPTOUSER_REQUEST: "DOWNLOAD_WHATSAPPTOUSER_REQUEST",
  DOWNLOAD_WHATSAPPTOUSER_SUCCESS: "DOWNLOAD_WHATSAPPTOUSER_SUCCESS",
  DOWNLOAD_WHATSAPPTOUSER_FAILURE: "DOWNLOAD_WHATSAPPTOUSER_FAILURE",
};
